import React from "react";
import classnames from "classnames";
import ReactSwitch from "react-switch";
import { EyeIcon, TrashIcon } from "@aureskonnect/react-ui";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";

import store, {
    setIsHistoryShopsModalOpened,
    setSelectedPaymentMethods,
    setSelectedHistoryPaymentMethods,
    setIsLoading,
} from "../store";
import { store as dataStore } from "@components/VerticalLayout/store";

import TimePastSvgIcon from "@components/Common/SvgIcons/TimePastSvgIcon";
import ErrorToast from "@components/Common/ErrorTost";
import {
    setActivationDeactivationMessageModalOpened,
    setMessage,
    setYesFunction,
} from "@components/Common/ConfirmationActivationDeactivationMessageModal/store";
import { generalConfigStore } from "@store";
import { isInformationModeConsumed } from "../hooks";
import {
    handleActivePaymentMethod,
    handleStateChange,
    checkIfSaleSupportIsArchived,
} from "./hooks";
import { useFetchGlobal } from "../../../../api/hooks";

type CustomIconsType = {
    selectedRowData: any;
    isArchivedPaymentMethodsClicked: boolean;
    isArchivedValidationModalOpened: boolean;
    setIsArchivedValidationModalOpened: Function;
    setSelectedRows: Function;
};

export function CustomIcons({
    selectedRowData,
    isArchivedPaymentMethodsClicked,
    isArchivedValidationModalOpened,
    setIsArchivedValidationModalOpened,
    setSelectedRows,
}: CustomIconsType) {
    const { t } = useTranslation();
    const { franchiseID, userID, operatorID } = useSnapshot(dataStore);
    const {
        isHistoryShopsModalOpened,
        paymentMethodsData,
        modify,
        isLoading,
    } = useSnapshot(store);
    const { itemsDisable } = useSnapshot(generalConfigStore);
    const [choiceState, setPaymentMethodState] = React.useState<boolean>(
        selectedRowData.selectedRow.isActive
    );

    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const uuidUser = localStorage.getItem("uuidUser");
    const { fetchGlobal } = useFetchGlobal();
    return (
        <React.Fragment>
            {selectedRowData.selectedRow?.subRows === undefined ? (
                <div className="d-flex justify-content-around">
                    {modify === true ? (
                        <>
                            <Tooltip
                                title={
                                    isArchivedPaymentMethodsClicked
                                        ? ""
                                        : choiceState === false
                                        ? t("Activate")
                                        : t("Unactivate")
                                }
                            >
                                <div>
                                    <ReactSwitch
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        handleDiameter={26}
                                        offColor="#f7b4b8"
                                        offHandleColor="#E30613"
                                        checked={choiceState}
                                        onChange={async (e: boolean) => {
                                            setMessage(
                                                choiceState
                                                    ? t(
                                                          "Caution, the Payment method may be used by other modules.\n Would you like to confirm the deactivation of the selected Payment method?"
                                                      )
                                                    : t(
                                                          "Would you like to confirm the activation of the selected Payment method?"
                                                      )
                                            );
                                            setYesFunction(() => {
                                                setPaymentMethodState(
                                                    !choiceState
                                                );
                                                handleStateChange(
                                                    e,
                                                    {
                                                        userID,
                                                        franchiseID,
                                                        operatorID,
                                                        uuidUser,
                                                    },
                                                    selectedRowData,
                                                    itemsDisable,
                                                    choiceState,
                                                    fetchGlobal
                                                );
                                            });
                                            setActivationDeactivationMessageModalOpened(
                                                true
                                            );
                                        }}
                                        onColor="#c2eddd"
                                        onHandleColor="#34C38F"
                                        width={50}
                                        height={20}
                                        className={`${classnames(
                                            "cmn_icn_BTenableDisable",
                                            {
                                                "not-allowed-icon__clz":
                                                    isArchivedPaymentMethodsClicked ||
                                                    isLoading,
                                            }
                                        )}`}
                                    />
                                </div>
                            </Tooltip>
                            <div>
                                {!isArchivedPaymentMethodsClicked ? (
                                    <Tooltip title={t("Archive")}>
                                        <div>
                                            <TrashIcon
                                                onClick={async () => {
                                                    setIsLoading(true);

                                                    let dataConsumed: any = await isInformationModeConsumed(
                                                        selectedRowData
                                                            .selectedRow.idShop,
                                                        franchiseID,
                                                        fetchGlobal
                                                    );

                                                    let isConsumed = dataConsumed.some(
                                                        (elt: any) =>
                                                            elt.id ===
                                                            selectedRowData
                                                                .selectedRow.id
                                                    );
                                                    if (isConsumed === true) {
                                                        ErrorToast(
                                                            t(
                                                                "Please note, you cannot archive an element used in a template"
                                                            )
                                                        );
                                                        setIsLoading(false);
                                                    } else {
                                                        setIsLoading(false);
                                                        setSelectedRows([
                                                            selectedRowData.selectedRow,
                                                        ]);
                                                        setIsArchivedValidationModalOpened(
                                                            !isArchivedValidationModalOpened
                                                        );
                                                    }
                                                }}
                                                height={25}
                                                width={25}
                                                fill="red"
                                                style={{ cursor: "pointer" }}
                                                className={`${classnames(
                                                    "ml-2 cmn_icn_BTarchived",
                                                    {
                                                        "not-allowed-icon__clz": isLoading,
                                                    }
                                                )}`}
                                            />
                                        </div>
                                    </Tooltip>
                                ) : (
                                    <Tooltip
                                        title={
                                            paymentMethodsData.find(
                                                (el: any) =>
                                                    el.id ===
                                                    selectedRowData.selectedRow
                                                        .id
                                            ) !== undefined
                                                ? ""
                                                : t("Unarchive")
                                        }
                                    >
                                        <div>
                                            <EyeIcon
                                                height={25}
                                                width={25}
                                                onClick={async (e: any) => {
                                                    setIsLoading(true);
                                                    let isArchived = await checkIfSaleSupportIsArchived(
                                                        userID,
                                                        franchiseID,
                                                        uuidUser as string,
                                                        selectedRowData,
                                                        i18nextLng,
                                                        t,
                                                        fetchGlobal
                                                    );
                                                    if (isArchived === true) {
                                                        ErrorToast(
                                                            `${t(
                                                                "Please note that  the unarchiving process could not be successfully completed. Please check the settings of the store(s) data."
                                                            )!}`
                                                        );
                                                        setIsLoading(false);
                                                    } else {
                                                        setIsLoading(false);
                                                        handleActivePaymentMethod(
                                                            selectedRowData,
                                                            {
                                                                userID,
                                                                franchiseID,
                                                                operatorID,
                                                                uuidUser,
                                                            },
                                                            itemsDisable,
                                                            fetchGlobal
                                                        );
                                                    }
                                                }}
                                                className={`${classnames(
                                                    "pointer__clz ml-2 cmn_icn_BTunarchive",
                                                    {
                                                        "not-allowed-icon__clz":
                                                            paymentMethodsData.find(
                                                                (el: any) =>
                                                                    el.id ===
                                                                    selectedRowData
                                                                        .selectedRow
                                                                        .id
                                                            ) !== undefined ||
                                                            isLoading,
                                                    }
                                                )}`}
                                            />
                                        </div>
                                    </Tooltip>
                                )}
                            </div>
                        </>
                    ) : null}
                    <Tooltip title={t("Consult history")}>
                        <div>
                            <TimePastSvgIcon
                                onClick={() => {
                                    setIsHistoryShopsModalOpened(
                                        !isHistoryShopsModalOpened
                                    );
                                    setSelectedHistoryPaymentMethods(
                                        selectedRowData.selectedRow
                                    );
                                    setSelectedPaymentMethods([
                                        {
                                            [selectedRowData.selectedRow
                                                .idShop]:
                                                selectedRowData.selectedRow.id,
                                        },
                                    ]);
                                }}
                                className={classnames(
                                    "pointer__clz ml-2 cmn_icn_BThistory",
                                    {
                                        "not-allowed-icon__clz": isLoading,
                                    }
                                )}
                            />
                        </div>
                    </Tooltip>
                </div>
            ) : null}
        </React.Fragment>
    );
}
